import { Chart, TooltipModel } from "chart.js";

const getOrCreateTooltip = (chart: Chart): HTMLDivElement => {
  let tooltipEl = chart.canvas.parentNode?.querySelector<HTMLDivElement>("div");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
    tooltipEl.style.borderRadius = "3px";
    tooltipEl.style.color = "white";
    tooltipEl.style.opacity = "1";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipEl.appendChild(table);
    chart.canvas.parentNode?.appendChild(tooltipEl);
  }

  return tooltipEl;
};

interface TooltipContext {
  chart: Chart;
  tooltip: TooltipModel<"bar" | "line">;
}

const get13FChartExternalTooltip = (context: TooltipContext): void => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b) => b.lines);

    const tableHead = document.createElement("thead");

    titleLines.forEach((title) => {
      const tr = document.createElement("tr");
      tr.style.borderWidth = "0";

      const th = document.createElement("th");
      th.style.borderWidth = "0";
      const text = document.createTextNode(title);

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement("tbody");
    // table body with grid layout with maximum two columns
    tableBody.style.display = "grid";
    tableBody.style.gridTemplateColumns = "1fr 1fr";
    tableBody.style.maxHeight = "240px";
    tableBody.style.width = "fit-content";
    tableBody.style.columnGap = "10px";
    tableBody.style.flexWrap = "wrap";

    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i];

      const span = document.createElement("span");
      span.style.background = colors.backgroundColor as string;
      span.style.marginRight = "10px";
      span.style.height = "10px";
      span.style.width = "10px";
      span.style.borderRadius = "100%";
      span.style.display = "inline-block";

      const tr = document.createElement("tr");
      tr.style.backgroundColor = "inherit";
      tr.style.borderWidth = "0";

      const td = document.createElement("td");
      td.style.borderWidth = "0";
      td.style.fontSize = "12px";
      td.style.whiteSpace = "nowrap";

      const text = document.createTextNode(body[0]);
      td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector("table");

    if (tableRoot) {
      // Remove old children
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }

      // Add new children
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }
  }

  const boundingRect = chart.canvas.getBoundingClientRect();
  const { offsetLeft: positionX } = chart.canvas;
  const top = boundingRect.top - 100;
  const left = positionX + tooltip.caretX;
  const translateX =
    tooltip.caretX > (boundingRect.width * 2) / 3 ? tooltip.width * 2 : 0;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
  tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
  tooltipEl.style.borderRadius = "10px";
  tooltipEl.style.transform = `translate(-${translateX}px, 0)`;
  tooltipEl.style.zIndex = "100";
};

export { get13FChartExternalTooltip };
